<template>
    <div id="content" v-if="dataLoaded">
      <popup v-show="hasPopup"
             :popup-type="getPopupType"
             :popup-action="getPopupAction"
             @popup-action="executePopupAction" />

        <div class="inner_white">
          <div class="filter">
            <div class="field_left">
              <search-input input-class="search" v-model="formFields.search"></search-input>
            </div>
            <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
          </div>
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr>
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                    <sorting-table-title
                            v-for="title in sortingTableTitles"
                            :key="title.id"
                            :column="title.column"
                            :sort="getActiveSort(title.column)"
                            @changeSorting="changeSorting"
                    >{{ title.name }}
                    </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <tbody>
                <registered-mac-address-batch-row
                        v-for="entity in entities"
                        :entity="entity"
                        :key="entity.id"
                        :selectedEntities="selectedEntities"
                        @input="select"
                        @deleteRegisteredMacAddressBatch="deleteEntity"
                ></registered-mac-address-batch-row>
                </tbody>
            </table>

            <list-action-line
                    :entities="entities"
                    :selected-entities="filteredSelectedEntities"
                    :multiple-action-options="multipleActionOptions"
                    @select-all="toggleSelectAll"
                    @run-multiple-action="runMultipleAction"
                    :offset="formFields.offset"
                    :limit="formFields.limit"
                    :total-count="totalCount"
                    @limit="setLimit"
                    @offset="setOffset"
                    ref="action_line"
            ></list-action-line>
        </div>
    </div>
</template>

<script>
  import RegisteredMacAddressBatchRow from "@/components/views/registeredMacAddress/RegisteredMacAddressBatchRow"
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "RegisteredMacAddressBatchList",
    components: {RegisteredMacAddressBatchRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'registeredMacAddressBatch',
        sortingTableTitles: [
					{id: 1, name: this.$gettext('Popis'), column: 'sDescription'},
					{id: 2, name: this.$gettext('Počet naimportovaných mac adres'), column: 'sMacAddressesCount'},
					{id: 3, name: this.$gettext('Datum vytvoření'), column: 'sDateCreated'},
                ],
			}
		},
		created(RegisteredMacAddressBatchService) {
			this.entityService = RegisteredMacAddressBatchService
			this.createdInit()
		},
    computed: {
      multipleActionOptions() {
        return [
          {value: 'choose', text: this.$gettext('Vyberte akci')},
          {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
        ];
      },
      csvHeaders(){
        return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
      },
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/BatchList.vue